const AcfHelper = {};

AcfHelper.handleInit = (key = "", callback) => {
    if (window.acf && key) {
        const fullBlockName = `${key}-block`;
        const rootAction = 'render_block_preview';
        const action = `${rootAction}/type=${fullBlockName}`;
        window.acf.addAction(action, () => {
            callback();
        });
    } else {
        callback();
    }
};

export default AcfHelper;
